import { render, staticRenderFns } from "./CompareTable.vue?vue&type=template&id=7854c266&scoped=true&"
import script from "./CompareTable.vue?vue&type=script&lang=js&"
export * from "./CompareTable.vue?vue&type=script&lang=js&"
import style0 from "./CompareTable.vue?vue&type=style&index=0&id=7854c266&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854c266",
  null
  
)

export default component.exports